import axios from "axios";

const planoSaudeStore = {
  namespaced: true,
  state: {
    meuPlano: null,
    solicitacoes: [],
    planos: [],
    simulador: [],
    planoSelecionado: 1,
    configDocs: [],
    docsAnexados: [],
    textoTermos: "",
    aceitouTermos: false,
    podeAlterarIncluir: false,
    status: [],
    statusSelecionado: 0,
    filtroSimulador: {
      codplano: 1,
      dependentes: [],
    },
  },
  mutations: {
    setMeuPlano(state, mp) {
      state.meuPlano = mp;
    },
    setSolicitacoes(state, solics) {
      state.solicitacoes = solics;
    },
    setPlanos(state, planos) {
      state.planos = planos;
    },
    setSimulador(state, simul) {
      state.simulador = simul;
    },
    setPlanoSelecionado(state, ps) {
      state.planoSelecionado = ps;
    },
    setConfigDocs(state, cfg) {
      state.configDocs = cfg;
    },
    setDocsAnexados(state, docs) {
      state.docsAnexados = docs;
    },
    setTextoTermos(state, txt) {
      state.textoTermos = txt;
    },
    setAceitouTermos(state, act) {
      state.aceitouTermos = act;
    },
    setPodeAlterarIncluir(state, pode) {
      state.podeAlterarIncluir = pode;
    },
    setStatus(state, status) {
      state.status = status;
    },
    setStatusSelecionado(state, statusSelec) {
      state.statusSelecionado = statusSelec;
    },
  },
  actions: {
    async getMeuPlano(context) {
      context.commit("setMeuPlano", null);
      await axios.get("/colaborador/plano-saude/meu-plano").then((res) => {
        if (res.data.success) {
          context.commit("setMeuPlano", res.data.data);
          context.dispatch("atualizarPermissaoAlterarIncluir");
        }
      });
    },
    async getSolicitacoes(context) {
      context.commit("setSolicitacoes", []);

      // Se tem statusSelecionado definido, usar a funcionalidade de filtro
      if (
        context.state.statusSelecionado !== undefined &&
        context.state.status.length > 0
      ) {
        if (context.state.statusSelecionado === 0) {
          // TODOS: buscar solicitações de todos os status
          let todasSolicitacoes = [];

          // Pegar todos os status (exceto TODOS que tem código 0)
          const statusParaBuscar = context.state.status.filter(
            (s) => s.codigo !== 0
          );

          for (const status of statusParaBuscar) {
            try {
              const res = await axios.get(
                "/colaborador/plano-saude/solicitacoes-geral",
                {
                  params: { status: status.codigo },
                }
              );

              if (res.data.success && res.data.data) {
                todasSolicitacoes = [...todasSolicitacoes, ...res.data.data];
              }
            } catch (error) {
              console.error(`Erro ao buscar status ${status.codigo}:`, error);
            }
          }

          context.commit("setSolicitacoes", todasSolicitacoes);
        } else {
          // Status específico
          await axios
            .get("/colaborador/plano-saude/solicitacoes-geral", {
              params: { status: context.state.statusSelecionado },
            })
            .then((res) => {
              if (res.data.success) {
                context.commit("setSolicitacoes", res.data.data);
              }
            });
        }
      } else {
        // Comportamento padrão: buscar as solicitações do próprio colaborador
        await axios
          .get("/colaborador/plano-saude/minhas-solicitacoes")
          .then((res) => {
            if (res.data.success) {
              context.commit("setSolicitacoes", res.data.data);
              context.dispatch("atualizarPermissaoAlterarIncluir");
            }
          });
      }
    },
    async getPlanos(context) {
      context.commit("setPlanos", []);
      await axios.get("/colaborador/plano-saude/planos").then((res) => {
        if (res.data.success) {
          context.commit("setPlanos", res.data.data);
        }
      });
    },
    async getSimulador(context) {
      context.commit("setSimulador", []);
      await axios
        .post(
          "/colaborador/plano-saude/simulador",
          JSON.stringify(context.state.filtroSimulador)
        )
        .then((res) => {
          if (res.data.success) {
            context.commit("setSimulador", res.data.data);
          } else {
            console.log("❌ API retornou success=false:", res.data);
          }
        })
        .catch((error) => {
          console.error("🚨 Erro na chamada da API simulador:", error);
        });
    },
    async getConfigDocs(context) {
      context.commit("setConfigDocs", []);
      await axios.get("/colaborador/plano-saude/config-docs").then((res) => {
        if (res.data.success) {
          context.commit("setConfigDocs", res.data.data);
        }
      });
    },
    async getTextoAceitarTermos(context) {
      context.commit("setTextoTermos", "");
      await axios
        .get("/colaborador/plano-saude/texto-aceitar-termos")
        .then((res) => {
          if (res.status == 200) {
            context.commit("setTextoTermos", res.data);
          }
        });
    },
    atualizarPermissaoAlterarIncluir(context) {
      // Verifica se há solicitações pendentes (não finalizadas)
      const solicitacoesPendentes = context.state.solicitacoes.filter(
        (s) => !s.status_final
      );

      // Verifica se o usuário solicitou cancelamento ou alteração do plano atual
      const meuPlano = context.state.meuPlano;
      const solicitouCancelamentoOuAlteracao =
        meuPlano &&
        (meuPlano.solicitoucancelamento || meuPlano.solicitoualteracao);

      // Permite alterar/incluir apenas se não há solicitações pendentes
      // e se não solicitou cancelamento ou alteração
      const podeAlterar =
        solicitacoesPendentes.length === 0 && !solicitouCancelamentoOuAlteracao;

      context.commit("setPodeAlterarIncluir", podeAlterar);
    },
    async getStatus(context) {
      context.commit("setStatus", []);
      await axios.post("/colaborador/plano-saude/status").then((res) => {
        if (res.data.success) {
          // Adicionar opção "TODOS" no início da lista
          const statusComTodos = [
            { codigo: 0, descricao: "TODOS" },
            ...res.data.data,
          ];
          context.commit("setStatus", statusComTodos);
        }
      });
    },
  },
  getters: {
    getterPlanoSelecionado(state) {
      var pos = state.simulador.findIndex(
        (s) => s.codigo == state.planoSelecionado
      );

      if (pos >= 0) return state.simulador[pos];
      return {
        codigo: 0,
        dependentes: [],
      };
    },
  },
};

export default planoSaudeStore;
